import * as Yup from 'yup'

export const rules = Yup.object().shape({
    email: Yup.string()
        .email('Ongeldig email adres')
        .required('Verplicht'),
    password: Yup.string()
        .required('Verplicht'),

});